import { createStyles } from '../../../../styles/helpers'

export default createStyles({
  btnChangeText: {}
})
